<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
     <a-form-item label="" name='status'>
      <a-month-picker  format="YYYY-MM" valueFormat='YYYY-MM'  @change="onMonthChange"/>
    </a-form-item>
    <a-form-item label="" name='source_type'>
      <a-select v-model:value="search.source_type" :style="{width:'160px'}" placeholder="全部">
        <a-select-option value="">全部渠道</a-select-option>
        <a-select-option value="1">会员生日礼包</a-select-option>
        <a-select-option value="2">品牌派券活动</a-select-option>
        <a-select-option value="3">直接发放</a-select-option>
        <a-select-option value="4">扫码活动</a-select-option>
        <a-select-option value="5">云店派券活动</a-select-option>
        <a-select-option value="6">首页优惠礼包</a-select-option>
        <a-select-option value="7">夺宝失败</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="" name='coupon_type'>
      <a-select v-model:value="search.coupon_type" :style="{width:'160px'}" placeholder="全部">
        <a-select-option value="">全部类型</a-select-option>
        <a-select-option :value="2">现金券</a-select-option>
        <a-select-option :value="3">代金券</a-select-option>
        <a-select-option :value="1">折扣券</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="" name='type'>
      <a-select v-model:value="search.use_type" :style="{width:'160px'}" placeholder="全部">
        <a-select-option value="">全部方式</a-select-option>
        <a-select-option value="1">云店使用</a-select-option>
        <a-select-option value="2">后台核销</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="使用时间" name='time'>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
    </a-form-item>
    <a-form-item label="门店" name='store_id'>
      <a-input placeholder="选择门店" style="width: 200px;" readonly v-model:value="search.store_name"></a-input>
      <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 3px;" v-if='search.store_name'  @click='search.store_name="";search.store_id="";' />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" @click="showStore=true">选择</a-button>
    </a-form-item>
    <a-form-item label="关键词" name='keyword'>
      <a-input-group compact :style="{width:'340px'}">
        <a-select v-model:value="search.search_type" style="width: 35%">
          <a-select-option value="coupon_name">券名称</a-select-option>
          <a-select-option value="coupon_id">卡券ID</a-select-option>
          <a-select-option value="openid">领取人ID</a-select-option>
          <a-select-option value="order_no">订单号</a-select-option>
          <a-select-option value="coupon_sn">券码</a-select-option>
        </a-select>
        <a-input style="width: 65%" v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
      </a-input-group>
    </a-form-item>
    
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" ghost v-has:usedExport="exportTable">导出</a-button>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" ghost v-has:usedReport="checkCreateReport">查看生成报表</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class="tableFixBox" :scroll="{ x: 'max-content'}">
        <template v-slot:openid="{ record }">
      <a-popover title="">
        <template #content>
          <div class="s_p24 s_flex_bian_c">
            <img class="s_bor100 width-100 height-100" :src="record.headimgurl ? record.headimgurl : require('@/assets/images/normal.png')" alt="" style="display:block;object-fit:cover;margin-right:20px">
            <div class="width80  ">
              <p class=" s_c333 ">微信昵称：{{record.nickname || '-'}}</p>
              <p class=" s_c333 ">客户Id：{{record.member_id || '-'}}</p>
              <p class=" s_c333 ">openId：{{record.openid || '-'}}</p>
              <p class=" s_c333 ">姓名  ：{{record.real_name || '-'}}</p>
              <p class=" s_c333  ">所在地区：{{record.address || '-'}}</p>
              <p class=" s_c333 " >关注时间：{{record.subscribe_time || '-'}}</p>
              <router-link :to="'/members/memberList/userDetail?member_id='+record.member_id" tag="a">会员详情</router-link>
            </div>
          </div>
        </template>
        <p class="s_flex_ali"> 
          <img class="width-50 height-50" :src="record.headimgurl ? record.headimgurl : require('@/assets/images/normal.png')" alt="" style="display:block;object-fit:cover;margin-right:10px">{{record.nickname || '-'}}</p>
      </a-popover>
    </template>
    <template v-slot:action="{ record }">
      <a-dropdown>
        <a class="ant-dropdown-link"> 操作
          <DownOutlined />
        </a>
        <template v-slot:overlay>
          <a-menu>
            <a-menu-item>
              <router-link :to="'/agent/agent_level/detail?type=look&id='+record.id">
                <a href="javascript:;">详情</a>
              </router-link>
            </a-menu-item>
            <a-menu-item>
              <a v-has:agentEdit="()=> agentAdd(record)" href="javascript:;">核销</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  <a-modal  :keyboard="false" title="查看详情" centered v-model:visible="reportVisible" destroyOnClose :width="1000" >
    <exportList :type='search.type' />
  </a-modal>
  <a-modal  :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1300' destroyOnClose :footer="null">
    <selectStore v-on:select="storeSelect" :selectList='[{id:search.store_id}]'></selectStore>
  </a-modal>
</template>
<script>
import { DownOutlined,CloseCircleFilled } from "@ant-design/icons-vue";
import { ref, onMounted,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getCouponLog,couponDetailReport } from "@/api/assets";
import { iscode } from "@/utils/app";
import { userExportTable } from "@/hooks/userCouponExport.js";
import exportList from "./exportList";
// 初始化默认筛选项数值
let defSearch = {
  keyword: "",
  type: '2',
  page: 1,
  use_type:'',
  coupon_type:'',
  limit: 10,
  year:'',
  month:'',
  source_type:'',
  search_type:'coupon_name',
  start_time:'',
  end_time:'',
};
export default {
  name:'usedList',
  components: { DownOutlined,exportList,CloseCircleFilled },
  setup() {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      time:[],
      total: 1,
      price_total:0,
      showStore:false
    });
    let columns = [
     {
        title: "领取人信息",
        dataIndex: "openid",
        key: "openid",
          fixed: 'left',
        slots: { customRender: "openid" },
      },
       {
        title: "券名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "卡券ID",
        dataIndex: "coupon_id",
        key: "coupon_id",
      },
      {
        title: "券码",
        dataIndex: "conpon_sn",
        key: "conpon_sn",
      },
      {
        title: "优惠",
        dataIndex: "amount_text",
        key: "amount_text"
      },
      {
        title: "使用/核销时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "券类型",
        dataIndex: "coupon_type_text",
        key: "coupon_type_text",
      },
      {
        title: "发放渠道",
        dataIndex: "source_type_text",
        key: "source_type_text"
      },
      {
        title: "订单号",
        dataIndex: "order_no",
        key: "order_no",
      },
      {
        title: "使用方式",
        dataIndex: "use_type_text",
        key: "use_type_text"
      },
      {
        title: "核销门店",
        dataIndex: "use_store",
        key: "use_store",
        customRender: ({ record }) => {
          return record.use_store ? record.use_store : '-'
        }
      },
    ];
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0]
      search.value.end_time = e[1]
      initData(search.value);
    }
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getCouponLog(values).then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    // 查看生成报表
    const reportVisible = ref(false);
    const checkCreateReport = async () => {
      reportVisible.value = true;
    };
    // 导出
    const { exportHandle } = userExportTable();
    const exportTable = () => {
      exportHandle({
        ...search.value,
        export_type: search.value.type,
        limit: 5000,
      });
    };
    onMounted(() => {
   
      initData(search.value);
    });
       const onMonthChange=(e)=>{
         console.log(e)
          if(!e){
        search.value.year=''
        search.value.month=''
        return
      }
      const d = e.split('-')
      search.value.year = d[0];
      search.value.month = d[1];
    }
    //选择门店
    const storeSelect = (data) => {
      search.value.store_name = data.store_name
      search.value.store_id = data.id
      state.showStore = false
    }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      onMonthChange,
      exportTable,
      checkCreateReport,
      reportVisible,
      storeSelect
    };
  },
};
</script>